import { render, staticRenderFns } from "./GroupStatus.vue?vue&type=template&id=23897b98&"
import script from "./GroupStatus.vue?vue&type=script&lang=js&"
export * from "./GroupStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports